export type ImageJob = {
  id: string;
  sourceId: string;
  kind?: "sketch" | "agent";
  sourceIds?: string[];
  sourceKey?: string;
  state: "running" | "ready" | "failed" | "unknown";
  prompt: string;
  size: "1K" | "2K" | "4K";
  created: string;
  error?: string;
  output?: { src: string; w: number; h: number; mimeType?: string };
};

export const GEMINI_IMAGE_MODEL = "gemini-3-pro-image";
// Published standard image-output component, checked 2026-09-19.
// Input, text/thinking tokens and taxes are additional; not a total-price quote.
export const imageOutputPrice = (size: string) =>
  size === "4K" ? "$0.24" : "$0.134";

export function validArea(
  value: unknown,
): value is { x: number; y: number; w: number; h: number } {
  if (!value || typeof value !== "object") return false;
  const a = value as Record<string, unknown>;
  return (
    [a.x, a.y, a.w, a.h].every(
      (v) => typeof v === "number" && Number.isFinite(v),
    ) &&
    Number(a.x) >= 0 &&
    Number(a.y) >= 0 &&
    Number(a.w) > 0 &&
    Number(a.h) > 0 &&
    Number(a.x) + Number(a.w) <= 1.000001 &&
    Number(a.y) + Number(a.h) <= 1.000001
  );
}
